module.exports = "https://coursera_assets.s3.amazonaws.com/images/f2aca76aca3bb0093e552168797f0ebf.svg";